import type { Vector3 } from '@react-three/fiber';
import { extend } from '@react-three/fiber';
import type { FC } from 'react';
// @ts-expect-error
import { MeshLine, MeshLineMaterial } from 'three.meshline';

extend({ MeshLine, MeshLineMaterial });

export type LineGroupProps = {
  lines: Vector3[][];
  position?: Vector3;
  color?: string;
  lineWidth?: number;
};

export const LineGroup: FC<LineGroupProps> = ({
  lines,
  position = [0, 0, 0.0001],
  color = 'white',
  lineWidth = 1,
}) => (
  <>
    <group position={position}>
      {lines.map((line, index) => (
        <mesh key={index}>
          <meshLine attach='geometry' points={line} />
          <meshLineMaterial
            attach='material'
            color={color}
            sizeAttenuation={1}
            lineWidth={lineWidth}
          />
        </mesh>
      ))}
    </group>
  </>
);
